import { InteractionType } from "../../models/interactions/Interaction";
import { openAnswersProperty } from "../../models/OpenAnswers";

const quizTypes = new Set<string>([
  InteractionType.MultipleChoiceQuiz,
  InteractionType.MultiselectQuiz,
  InteractionType.MultipleChoiceGraphicsQuiz,
  InteractionType.MultiSelectGraphicsQuiz,
  InteractionType.ButtonsQuiz,
  InteractionType.ImageButtonQuiz,
  InteractionType.StatementQuiz,
]);

// Normalize even current-version documents on hydration, including sequence
// nodes and stored feedback. Preserve identity and authored values when possible.
export function ensureOpenAnswersProperties<T>(value: T): T {
  if (!value || typeof value !== "object") return value;
  if (Array.isArray(value)) {
    const next = value.map(ensureOpenAnswersProperties);
    return (next.some((item, index) => item !== value[index]) ? next : value) as T;
  }
  const record = value as Record<string, unknown>;
  let next = record;
  for (const [key, child] of Object.entries(record)) {
    const normalized = ensureOpenAnswersProperties(child);
    if (normalized !== child) next = { ...next, [key]: normalized };
  }
  if (typeof next.type === "string" && quizTypes.has(next.type)) {
    const properties = Array.isArray(next.properties) ? next.properties : [];
    if (!properties.some((property) => property?.id === openAnswersProperty.id)) {
      next = { ...next, properties: [...properties, { ...openAnswersProperty }] };
    }
  }
  return next as T;
}
